import { createSelector } from 'reselect';

const historyFormSelector = state => state.history.historyForm;

export const getHistoryForm = createSelector(
    historyFormSelector,
    historyForm => historyForm,
);
